import { render, staticRenderFns } from "./JobQuoteApprovalTable.vue?vue&type=template&id=b9fd612c"
import script from "./JobQuoteApprovalTable.vue?vue&type=script&lang=js"
export * from "./JobQuoteApprovalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports